import { render, staticRenderFns } from "./FormLegend.vue?vue&type=template&id=1a668eca&scoped=true&"
import script from "./FormLegend.vue?vue&type=script&lang=js&"
export * from "./FormLegend.vue?vue&type=script&lang=js&"
import style0 from "./FormLegend.vue?vue&type=style&index=0&id=1a668eca&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a668eca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VRow,VTextField})
